/**
 * Ensures a phone number has the +1 country code prefix
 * @param {string} phoneNumber - The phone number to format
 * @returns {string} Phone number with +1 prefix or empty string for empty input
 */
export const appendCountryCode = phoneNumber => {
    if (!phoneNumber) {
        return '';
    }

    // Remove any non-digit characters except +
    const cleanNumber = phoneNumber.replace(/[^\d+]/g, '');

    // Check if already has +1 prefix
    if (cleanNumber.startsWith('+1')) {
        return cleanNumber;
    }

    // Check if starts with just 1
    if (cleanNumber.startsWith('1') && cleanNumber.length === 11) {
        return `+${cleanNumber}`;
    }

    // Add +1 prefix
    return `+1${cleanNumber}`;
};

/**
 * formats a phone number to (NNN) NNN-NNNN format
 * @param phoneNumberString
 * @returns
 */
export const formatDisplayPhoneNumber = phoneNumberString => {
    if (phoneNumberString?.length === 10) {
        const cleaned = `${phoneNumberString}`.replace(/\D/g, '');
        const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
        if (match) {
            return `(${match[1]}) ${match[2]}-${match[3]}`;
        }
    }
    return '';
};
